import React, { Component, useEffect } from 'react';
import NuxeoConnect from './components/nuxeo-connect/NuxeoConnect';
import './App.css';

import ConfigurationManager from './configuration/ConfigurationManager';
import Header from './components/header/Header';
import MarketingSubmissionFields3 from './components/marketing-submission-fields/MarketingSubmissionFields3';
import SucessPage from './components/success-page/SuccessPage';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import ProductSubmissionFields from './components/product-submission-fields/ProductSubmissionFields'
import PackageSubmissionFields from './components/package-submission-fields/PackageSubmissionFields'
import GTESubmissionFields from './components/gte-submission-fields/GTESubmissionFields'
import PublishingSubmissionFields from './components/publishing-plan-submission-fields/PublishingPlanSubmissionFields'
import HomePage from './components/home-page/HomePage'
import { initGA } from '.';


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            jobSubmitSuccess: false,
            currentUser: null
        };
        this.jobId = '';

        //Process the Env
        ConfigurationManager.environment = process.env;

        //bind all event listener
        this._handleConnect = this
            ._handleConnect
            .bind(this);
        this._handleJobSuccess = this
            ._handleJobSuccess
            .bind(this);
    }

    get currentUser() {
        return this.state.currentUser;
    }

    set currentUser(currentUser) {
        this.setState({ currentUser: currentUser });
    }

    get isLoading() {
        return this.state.isLoading;
    }

    set isLoading(isLoading) {
        this.setState({ isLoading: isLoading });
    }

    componentDidMount() {
        console.log('mounted:', window.location.href);
        initGA();
    }

    _handleConnect(event) {
        this.currentUser = event.detail.user;
        this.isLoading = false;
    }

    async _handleJobSuccess(event) {
        this.jobId = event.detail.jobId;
        await this.setState({ isLoading: false, jobSubmitSuccess: true });
    }
    marketingSubmissionPage = (props) => {
        return (<MarketingSubmissionFields3 onSuccess={this._handleJobSuccess} user={this.state.currentUser} />)
    }
    productSubmissionPage = (props) => {
        return (<ProductSubmissionFields onSuccess={this._handleJobSuccess} user={this.state.currentUser} />)
    }
    packageSubmissionPage = (props) => {
        return (<PackageSubmissionFields onSuccess={this._handleJobSuccess} user={this.state.currentUser} />)
    }
    gteSubmissionPage = (props) => {
        return (<GTESubmissionFields onSuccess={this._handleJobSuccess} user={this.state.currentUser} />)
    }
    publishingSubmissionPage = (props) => {
        return (<PublishingSubmissionFields onSuccess={this._handleJobSuccess} user={this.state.currentUser} />)
    }
    homePage = (props) => {
        return (<HomePage />)
    }
    render() {
        const { currentUser, jobSubmitSuccess } = this.state

        return (
            <div className="App">
                <NuxeoConnect onConnect={this._handleConnect} />
                <Header currentUser={currentUser} /> {
                    jobSubmitSuccess
                        ? <SucessPage jobId={this.jobId}></SucessPage>
                        :
                        <Router>
                            <Switch>
                                <Route exact path='/home' component={this.homePage} />
                                <Route exact path='/submit/marketing' component={this.marketingSubmissionPage} />
                                <Route exact path='/submit/product' component={this.productSubmissionPage} />
                                <Route exact path='/submit/packaging' component={this.packageSubmissionPage} />
                                <Route exact path='/submit/publishing' component={this.publishingSubmissionPage} />
                                <Route exact path='/submit/gte' component={this.gteSubmissionPage} />
                            </Switch>
                        </Router>
                }
            </div>

        );
    }
}

export default App;